


import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "src/shared/components/Component";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
import "src/features/home/pages/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/shared/components/withAppContext";
import { withRouter } from 'react-router-dom';
import AgreementComponent from "src/shared/components/agreementModal";
import Footerpage from "src/shared/components/footer";
import LoadingSpinner from "src/shared/components/LoadingSpinner";
import Headerpage from "src/shared/components/header";
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box } from '@material-ui/core/';
// import { Edit } from '@material-ui/icons-material';
const styles = () => ({
    childTemplate: {
        paddingLeft: 80,
    },
    listItem: {
        "&:hover": {
            backgroundColor: "#e6e6e6",
        },
        backgroundColor: "white",
    },
});

type IProps = IAxiosProps & IAppContext &
    WithStyles<keyof ReturnType<typeof styles>> & { history: any };

interface ITemplatesPageState {
    paymentDetails: any
    loader: boolean;
    openAgreement: boolean;
    paymentMethodType: number;
    isAgree: boolean;
    isClikable: boolean,
    showMessage: boolean


}

const Home = withStyles(styles)(
    withAxios(
        class LeadPage extends Component<IProps, ITemplatesPageState> {
            public state = this.buildState({
                paymentDetails: {},
                loader: false,
                openAgreement: false,
                paymentMethodType: 0,
                isAgree: false,
                isClikable: true,
                showMessage: false
            });
            public componentWillMount(): void {
                this.props.getNewLoginUserDetails()
            }
            public componentDidMount() {
                this.getAllPlanHandler()
            }
            public componentWillUnmount() {
                // Cleanup if needed
            }

            public openAgreementModal() {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.setState({ openAgreement: true })
            }
            public closeAgreementModal() {
                this.setState({ openAgreement: false })
            }

            public paymentMethodsType(id: any) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.setState({ paymentMethodType: id })

            }

            public async getAllPlanHandler() {
                this.setState({ loader: true })
                // const upgradeDetailsRaw = sessionStorage.getItem("upgradeDetails");
                
                const UserDetails = sessionStorage.getItem("newUserDetails");
                const newUserDetails = UserDetails ? JSON.parse(UserDetails) : null;
                // const upgradeDetails = upgradeDetailsRaw ? JSON.parse(upgradeDetailsRaw) : null;
                const planId =
                    this.props.newUserDetails?.subscriptionPlan?.id ||
                    newUserDetails?.subscriptionPlan?.id ||
                    "";

                const addonId =
                    this.props.newUserDetails?.addonPlan ||
                    newUserDetails?.addonPlan ||
                    [];

                const membershipId =
                    this.props.newUserDetails?.membership_id ||
                    "";

                const paymentData = {
                    // "payment_method":"cheque",
                    "plan_id": planId,
                    "addon_id": addonId,
                    "membership_id": membershipId
                }
                const res: any = await this.buildPost(this, "payment/planPayNow")(paymentData)
                if (res.status && Object.keys(res?.data)?.length > 0) {
                    this.setState({ paymentDetails: { ...res?.data, addon: res?.data?.addon == null ? [] : res?.data?.addon, plan: res?.data?.plan != null ? res?.data?.plan : {} } }, () => {
                        console.log("paymentDetails======>", this.state.paymentDetails)
                    })
                    this.setState({ loader: false })
                } else {
                    this.setState({ loader: false })
                }
                // this.setState({ user: res })
            }
            public TwoDecimalFloat(amount: any) {
                const valueAnount = amount;
                const roundedNumber = valueAnount.toFixed(2);
                return roundedNumber

            }

            public async acceptAgreement(pdfFile: any) {
                this.props.onChangeUserDetails({
                    ...this.props?.newUserDetails,
                    agreementFile: pdfFile,
                });
                this.setState({ isAgree: true })
                console.log("this prop 4", this.props)
                if (this.props?.user?.email || this.props?.newUserDetails?.email) {
                    const isCheck = await this.emailExistingCheck()
                    if (isCheck) {
                        if (this.state?.paymentDetails?.total > 0) {
                            if (this.state.paymentMethodType === 1) {
                                this.submitUserHandler()
                            } else if (this.state.paymentMethodType === 2) {
                                this.submitStripeHandler()
                            }

                        } else {
                            this.submitFreeUserHandler()
                        }
                    } else {
                        alert("This email is already registered. Please try another one.")
                    }
                } else {
                    alert("Complete sign-up flow first.")
                }

            }

            public async emailExistingCheck() {
                console.log("this.props?.user?.email", this.props)
                if (this.props?.user?.email || this.props?.newUserDetails?.email) {
                    this.setState({ loader: true })
                    setTimeout(() => {
                        this.setState({ showMessage: true });
                    }, 3000);
                    const resEmail: any = await this.buildGet(this, `school/user/${this.props?.user?.email || this.props?.newUserDetails?.email}`)()
                    console.log("resEmail======>", resEmail)
                    if (resEmail?.status === false) {
                        this.setState({ loader: false })
                        return false
                    } else {
                        this.setState({ loader: false })
                        return true
                    }
                } else {
                    return false
                }

            }
            public submitUserHandler = async () => {
                const dataTemp = {
                    payment_method: 'cheque',
                    plan_id: this.props?.newUserDetails?.subscriptionPlan?.id?.toString(),
                    addon_id: this.props?.newUserDetails?.addonPlan || [],
                    agreements: this.props?.newUserDetails?.agreementFile || "",
                    cheque: this.props?.newUserDetails?.cheque || "",
                    email: this.props?.user?.email || this.props?.newUserDetails?.email.toLowerCase() || "",
                    password: this.props?.newUserDetails?.password || "",
                    firstName: this.props?.newUserDetails?.firstName || "",
                    lastName: this.props?.newUserDetails?.lastName || "",
                    schoolOrganization: this.props?.newUserDetails?.schoolOrganization || "",
                    mascot: this.props?.newUserDetails?.mascot || "",
                    phone: this.props?.newUserDetails?.phone || "",
                    schoolType: this.props?.newUserDetails?.schoolType || "",
                }
                this.setState({ loader: true })
                const data = new FormData();
                data.append('payment_method', dataTemp.payment_method);
                data.append('plan_id', dataTemp.plan_id);
                data.append('agreements', dataTemp.agreements);
                data.append('cheque', "");
                data.append('email', dataTemp.email);
                data.append('password', dataTemp.password);
                data.append('firstName', dataTemp.firstName);
                data.append('lastName', dataTemp.lastName);
                data.append('schoolOrganization', dataTemp.schoolOrganization);
                data.append('mascot', dataTemp.mascot);
                data.append('phone', dataTemp.phone);
                data.append('schoolType', dataTemp.schoolType);
                if (dataTemp?.addon_id?.length > 0) {
                    dataTemp.addon_id.map((itm: any) => {
                        data.append('addon_id[]', itm.toString());

                    })

                }
                const res: any = await this.buildPost(
                    this,
                    `payment/planPayConfirm`
                )(data);
                console.log("res=====>planPayConfirm", res)
                this.props.onChangeUserDetails({
                    ...this.props?.newUserDetails,
                    paymentRes: res,
                });

                if (res?.status) {
                    setTimeout(() => {
                        this.setState({ loader: false })
                        this.props.history.push("/payment")
                    }, 5000);
                } else {
                    this.setState({ loader: false })
                }

            }

            public submitStripeHandler = async () => {
                const dataTemp = {
                    payment_method: 'stripe',
                    plan_id: this.props?.newUserDetails?.subscriptionPlan?.id?.toString(),
                    agreements: this.props?.newUserDetails?.agreementFile || "",
                    email: this.props?.user?.email || this.props?.newUserDetails?.email.toLowerCase() || "",
                    password: this.props?.newUserDetails?.password || "",
                    firstName: this.props?.newUserDetails?.firstName || "",
                    lastName: this.props?.newUserDetails?.lastName || "",
                    schoolOrganization: this.props?.newUserDetails?.schoolOrganization || "",
                    mascot: this.props?.newUserDetails?.mascot || "",
                    phone: this.props?.newUserDetails?.phone || "",
                    addon_id: this.props?.newUserDetails?.addonPlan || [],
                    schoolType: this.props?.newUserDetails?.schoolType || ""
                }
                this.setState({ loader: true })
                const data = new FormData();
                console.log("dataTemp.agreements", dataTemp)
                data.append('payment_method', dataTemp.payment_method);
                data.append('agreements', dataTemp.agreements);
                data.append('email', dataTemp.email);
                data.append('password', dataTemp.password);
                data.append('firstName', dataTemp.firstName);
                data.append('lastName', dataTemp.lastName);
                data.append('plan_id', dataTemp.plan_id)
                data.append('schoolOrganization', dataTemp.schoolOrganization);
                data.append('mascot', dataTemp.mascot);
                data.append('phone', dataTemp.phone);
                data.append('schoolType', dataTemp.schoolType);
                if (dataTemp?.addon_id?.length > 0) {
                    dataTemp.addon_id.map((itm: any) => {
                        data.append('addon_id[]', itm.toString());
                    })
                }
                console.log("FormData agreements:", data.get('agreements'));
                const res: any = await this.buildPost(
                    this,
                    `/payment/planPayConfirmStripe`
                )(data);
                this.props.onChangeUserDetails({
                    ...this.props?.newUserDetails,
                    stripeResponse: res,
                    isStripe: true
                });

                console.log("/payment/planPayConfirmStripe", res)
                if (res?.status) {
                    this.setState({ loader: false })
                    window.location.href = res?.data?.payment_url
                } else {
                    this.setState({ loader: false })
                }
            }

            public submitFreeUserHandler = async () => {

                // this.props.history.push("/payment")
                const dataTemp = {
                    payment_method: 'free',
                    plan_id: this.props?.newUserDetails?.subscriptionPlan?.id?.toString(),
                    agreements: this.props?.newUserDetails?.agreementFile || "",
                    email: this.props?.user?.email || this.props?.newUserDetails?.email.toLowerCase() || "",
                    password: this.props?.newUserDetails?.password || "",
                    firstName: this.props?.newUserDetails?.firstName || "",
                    lastName: this.props?.newUserDetails?.lastName || "",
                    schoolOrganization: this.props?.newUserDetails?.schoolOrganization || "",
                    mascot: this.props?.newUserDetails?.mascot || "",
                    phone: this.props?.newUserDetails?.phone || "",
                    schoolType: this.props?.newUserDetails?.schoolType || "",
                }
                this.setState({ loader: true })
                const data = new FormData();
                data.append('payment_method', dataTemp.payment_method);
                data.append('agreements', dataTemp.agreements);
                data.append('email', dataTemp.email);
                data.append('password', dataTemp.password);
                data.append('firstName', dataTemp.firstName);
                data.append('lastName', dataTemp.lastName);
                data.append('plan_id', dataTemp.plan_id)
                data.append('schoolOrganization', dataTemp.schoolOrganization);
                data.append('mascot', dataTemp.mascot);
                data.append('phone', dataTemp.phone);
                data.append('schoolType', dataTemp.schoolType);
                const res: any = await this.buildPost(
                    this,
                    `payment/planRequest`
                )(data);
                console.log("res=====>planPayConfirm", res)
                this.props.onChangeUserDetails({
                    ...this.props?.newUserDetails,
                    paymentRes: res,
                });
                this.setState({ loader: false })
                if (res?.status) {
                    setTimeout(() => {
                        this.props.history.push("/payment")
                    }, 2000)
                }

            }

            public declineAgreement() {
                this.setState({ isAgree: false })
            }


            public render() {
                const finalDetails = {
                    email: this.props.user?.email || this.props?.newUserDetails?.email?.toLowerCase(),
                    firstName: this.props?.newUserDetails?.firstName,
                    lastName: this.props?.newUserDetails.lastName,
                    school: this.props?.newUserDetails?.schoolOrganization,
                    plan: this.props?.newUserDetails?.subscriptionPlan,
                    paymentMethodType: this.state.paymentMethodType,
                    payable: this.state?.paymentDetails?.total - this.state.paymentDetails.discount_amount,

                }
                return (
                    <div className="contat-main-bg-color">
                        {this.state.loader &&
                            <div className="loader-bg-color">
                                <LoadingSpinner />
                                {this.state.showMessage && (
                                    <div style={{ display: "flex", justifyContent: "center" }}>{this.state.showMessage && (
                                        <p style={{
                                            color: "#fff", position: 'absolute',
                                            top: '42%',
                                            fontSize: "30px",
                                            paddingLeft: "45px",
                                            fontFamily: "'Poppins' !important",
                                            zIndex: 1000,
                                        }}>We are currently in progress. Please stand by.</p>
                                    )}</div>
                                )}</div>
                        }
                        <Headerpage />


                        <div className="container">
                            <AgreementComponent
                                openAgreementModal={() => {
                                    this.openAgreementModal()
                                }}
                                closeAgreementModal={() => {
                                    this.closeAgreementModal()
                                }}
                                acceptAgreement={(pdfFile: any) => {
                                    this.setState({ isClikable: false })
                                    this.acceptAgreement(pdfFile)
                                }}
                                declineAgreement={() => {
                                    this.declineAgreement()
                                }}
                                openAgreement={this.state.openAgreement}
                                details={finalDetails}
                            />
                            <div className="purchase-content">
                                <div className="row purchase-row">
                                    <div className="col-lg-8">
                                        {Object.keys(this.state?.paymentDetails)?.length > 0 && <div className="purchase-inner-content">
                                            <div className="purchase-inform check-inform"><h3>Purchase Information</h3></div>
                                            {Object?.keys(this.state?.paymentDetails?.plan)?.length > 0 && <div className="subscription-fee">
                                                <div className="subscription-fee-flex">
                                                    <div className="sub-yearly">
                                                        <h4>Subscription {this.state?.paymentDetails?.plan?.id === 1 ? "Fee" : "Fees"} <br />
                                                            ({this.state?.paymentDetails?.plan?.title}/{this.state?.paymentDetails?.plan?.payment_frequency_type.charAt(0).toUpperCase() + this.state?.paymentDetails?.plan?.payment_frequency_type.slice(1)})</h4>
                                                    </div>
                                                    <div>
                                                        <h3> ${this.TwoDecimalFloat(this.state?.paymentDetails?.plan?.price)}</h3>
                                                    </div>
                                                </div>
                                            </div>}
                                            {console.log("this.state?.paymentDetails?.addon", this.state?.paymentDetails)}
                                            {this.state?.paymentDetails?.addon?.length > 0 && this.state?.paymentDetails?.addon.map((item: any) => {
                                                return (
                                                    <div className="customizeable" key={item?.id}>
                                                        <div className="subscription-sub-flex">
                                                            <div className="sub-custom">
                                                                <h4>{item?.title}
                                                                    <br />
                                                                    (Add on) </h4>
                                                            </div>
                                                            <div>
                                                                <h3>${this.TwoDecimalFloat(item?.price)}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )

                                            })



                                            }
                                            <div className="totalprice"><h3>Total amount to pay: ${this.TwoDecimalFloat(this.state?.paymentDetails?.total)}</h3></div>
                                            {this.state?.paymentDetails?.total > 0 ? <>
                                                <div className="continuetosecure"
                                                    onClick={() => {
                                                        if (this.state.isClikable) {
                                                            this.paymentMethodsType(1)
                                                            this.openAgreementModal()
                                                        }
                                                    }}
                                                >
                                                    <h5>Pay by Check</h5>
                                                </div>
                                                <div>
                                                    <button className="down-invoice" onClick={() => {
                                                        if (this.state.isClikable) {
                                                            this.paymentMethodsType(2)
                                                            this.openAgreementModal()
                                                        }
                                                    }}>
                                                        Pay by Credit Card
                                                    </button>
                                                </div>
                                            </>
                                                : <>
                                                    <div className="continuetosecure" onClick={() => {
                                                        if (this.state.isClikable) {
                                                            this.paymentMethodsType(0)
                                                            this.openAgreementModal()
                                                        }
                                                    }}><h5>Continue</h5></div>
                                                </>}
                                            {/* // added note for 3% processing fee */}



                                            {this.state?.paymentDetails?.plan?.title !== "Free Trial" && (
                                                <p className="creditText">
                                                    Please note that payments made by credit card are subject to an industry-standard 3% processing fee.
                                                    {/* Total will be: $
    {this.TwoDecimalFloat(this.state?.paymentDetails?.total * 1.03)} */}

                                                    {/* (Base: $
    {this.TwoDecimalFloat(this.state?.paymentDetails?.total)} + Fee: $
    {this.TwoDecimalFloat(this.state?.paymentDetails?.total * 0.03)}) */}
                                                </p>
                                            )}

                                        </div>}

                                    </div>

                                </div>
                            </div>

                        </div>
                        <Footerpage />


                    </div>
                );
            }
        }
    )
);



const HomeFunction = (props: any) => (
    <AppContextConsumer>{(context) => <Home {...context} history={props?.history} />}</AppContextConsumer>
);
export default withRouter(HomeFunction);












// WEBPACK FOOTER //
// ./src/features/director/pages/payment/purchase.tsx